/**
 * Sample Slot Registrar
 *
 * 演示第三方 Mod 如何通过 DI 获取 IUserCenterSlotsService 实例，
 * 注册自己的 UI 到用户中心。
 */
import { SampleSlotPanel } from './sample-slot-panel.js';
import { SampleSlotIcon } from './sample-slot-icon.js';
/**
 * 示例 slot 注册器
 *
 * 通过依赖注入获取 userCenterSlots 服务，注册示例面板。
 */
export class SampleSlotRegistrar {
    constructor(deps) {
        const { userCenterSlots } = deps;
        // ─── 注册一个 slot 到用户中心 ───
        userCenterSlots.registerSlot({
            id: 'sample-slot',
            label: '示例功能',
            icon: SampleSlotIcon,
            component: SampleSlotPanel,
            order: 10, // 排序权重，越小越靠前
            modName: 'sample-slot-client',
        });
    }
}
//# sourceMappingURL=sample-slot-registrar.js.map